import React from 'react';

import PropTypes from 'prop-types';

export default function CaretIcon2({
  width = 12,
  height = 7,
  color = '#333333',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 7"
      fill="none"
      {...rest}
    >
      <path
        d="M1.416 4.76837e-07L0 1.33657L6 7L12 1.33657L10.584 4.76837e-07L6 4.34951L1.416 4.76837e-07Z"
        fill={color}
      />
    </svg>
  );
}

CaretIcon2.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
